export const fetchSquad = async (teamId: number) => {
  const response = await fetch(`/squads/${teamId}`);
  const data = await response.json();  
  return data;
}

export const appendRatings = async (squad: { response: { players: any; }[];  }, teamId: number) => {
  for (let player of squad.response[0].players) {
    try {
      await ratePlayer(player.id, player.rating, teamId);
    } catch (err) {
      console.error(`Failed to rate player ${player.id}:`, err);
    }
  }
  
  // Re-fetch the squad to get the updated player ratings
  const updatedSquad = await fetchSquad(teamId);

  return updatedSquad;
};


export const ratePlayer = async (playerId: number, newRating: number, squadId: number) => {
  // Get current player data
  const playerResponse = await fetch(`/squads/${squadId}/players/${playerId}`);
  const playerData = await playerResponse.json();

  // Add new rating to existing ratings
  const ratings = [...playerData.ratings, newRating];
  
  // Calculate average rating
  const avgRating = ratings.reduce((acc, curr) => acc + curr, 0) / ratings.length;

  // Update player data
  const response = await fetch(`/squads/${squadId}/players/${playerId}/rate`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ rating: avgRating, ratings }), // update the rating and ratings fields
  });

  if (!response.ok) {
    throw new Error(`Failed to rate player: ${response.statusText}`);
  }
  
  const updatedPlayer = await response.json();
  return updatedPlayer;
};
